import { usePreloadCacheContext } from 'framework/hooks/usePreloadCacheContext';
import { LocationsPreloadCacheContext } from './LocationsPreloadCacheContext';
import { ILocation, ILocationSummary } from 'gen/ApiClient';

export function useNonDeletedLocationSummaries(): [ILocationSummary[], () => void] {
	const [data, reload] = usePreloadCacheContext(LocationsPreloadCacheContext);
	return [data.nonDeletedSummaries, reload];
}

export function useAllLocations(): [ILocation[], () => void] {
	const [data, reload] = usePreloadCacheContext(LocationsPreloadCacheContext);
	return [data.locations, reload];
}
